export default "__VITE_ASSET__4fd95496__"